<app-progress-bar></app-progress-bar>
<router-outlet></router-outlet>
